/**
 * https://en.wikipedia.org/wiki/Standard_52-card_deck
 */
import styles from "./BackCard.module.css";

interface Props {
  pickACard?: boolean;
  style?: React.CSSProperties;
}

export default function BackCard({ pickACard, style }: Props) {
  const backCardClasses =
    styles.backCard + (pickACard ? ` ${styles.pickACard}` : "");
  return (
    <div className={backCardClasses} style={style}>
      {pickACard && (
        <button className={styles.pickButton} autoFocus>
          <span className="sr-only">Pick a card</span>
        </button>
      )}
    </div>
  );
}
